export interface TourStep {
  key: string;
  /** 미지정 → 화면 중앙(welcome). 지정 시 해당 셀렉터 요소를 하이라이트. */
  targetSelector?: string;
  /** i18n 타이틀 키 */
  titleKey: string;
  /** i18n 본문 키 */
  bodyKey: string;
  /** 기본 auto — 아래 공간 우선, 부족하면 위/좌/우 */
  placement?: 'auto' | 'top' | 'bottom' | 'left' | 'right';
}

/**
 * queue #669 §UAT-2026-07-09-R669 §R669-3 — 온보딩 투어 6 스텝(실존 요소만).
 * 순서 = 개관(환영) → 페이지 본문(카드) → 헤더(검색) → 사이드바(카탈로그 → 스캐폴드 → 시작하기).
 * 대상 셀렉터는 §R669-1 신규 식별 속성(`data-tour="getting-started-card"` ·
 * `data-tour="global-search"` · ui-kit `SideNav` `data-nav-path={path}`)을 그대로 사용한다.
 */
export const ONBOARDING_TOUR_STEPS: TourStep[] = [
  {
    key: 'welcome',
    titleKey: 'gettingStartedGuide.tour.welcome.title',
    bodyKey: 'gettingStartedGuide.tour.welcome.body',
  },
  {
    key: 'card',
    targetSelector: '[data-tour="getting-started-card"]',
    titleKey: 'gettingStartedGuide.tour.card.title',
    bodyKey: 'gettingStartedGuide.tour.card.body',
  },
  {
    key: 'search',
    targetSelector: '[data-tour="global-search"]',
    titleKey: 'gettingStartedGuide.tour.search.title',
    bodyKey: 'gettingStartedGuide.tour.search.body',
  },
  {
    key: 'catalog',
    targetSelector: '[data-nav-path="/showcase"]',
    titleKey: 'gettingStartedGuide.tour.catalog.title',
    bodyKey: 'gettingStartedGuide.tour.catalog.body',
  },
  {
    key: 'scaffold',
    targetSelector: '[data-nav-path="/scaffold"]',
    titleKey: 'gettingStartedGuide.tour.scaffold.title',
    bodyKey: 'gettingStartedGuide.tour.scaffold.body',
  },
  {
    key: 'finish',
    targetSelector: '[data-nav-path="/getting-started"]',
    titleKey: 'gettingStartedGuide.tour.finish.title',
    bodyKey: 'gettingStartedGuide.tour.finish.body',
  },
];
